import { render } from "./EevntReport.vue?vue&type=template&id=74350bf8&scoped=true"
import script from "./EevntReport.vue?vue&type=script&lang=js"
export * from "./EevntReport.vue?vue&type=script&lang=js"

import "./EevntReport.vue?vue&type=style&index=0&id=74350bf8&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74350bf8"]])

export default __exports__